import React from "react";
import { Link } from "react-router-dom";

import avatar2 from "../../images/avatar/avatar2.jpg";
import avatar3 from "../../images/avatar/avatar3.jpg";
import avatar4 from "../../images/avatar/avatar4.jpg";

const CommentsArea: React.FC = () => {
  return (
    <div className="comment_area mb-70">
      <h3 className="comment-title">Comments (3)</h3>

      <ul className="comments_list unordered_list_block list-unstyled">

        {/* COMMENT 1 */}
        <li>
          <div className="comment_item">
            <div className="comment_author_thumbnail">
              <img src={avatar2} alt="Avatar" />
            </div>

            <div className="comment_author_content">
              <h4 className="comment_author_name">Ethan Reynolds</h4>
              <div className="comment_time">November 24, 2026</div>
              <p>"Great guide. I tried cheap TikTok views on two clips last week and my reach doubled. The refill button is a bonus."</p>

              <Link to="/blod-details" className="comment_reply_btn xb-border">
                Reply
              </Link>
            </div>
          </div>

          {/* REPLY TO COMMENT 1 */}
          <ul className="comments_list unordered_list_block list-unstyled">
            <li>
              <div className="comment_item">
                <div className="comment_author_thumbnail">
                  <img src={avatar3} alt="Avatar" />
                </div>

                <div className="comment_author_content">
                  <h4 className="comment_author_name">Priya Ramirez</h4>
                  <div className="comment_time">November 26, 2026</div>
                  <p>"I resell Instagram likes to small shops. Low prices on SMMPanel-Cheap made my margins much better."</p>

                  <Link to="/blod-details" className="comment_reply_btn xb-border">
                    Reply
                  </Link>
                </div>
              </div>
            </li>
          </ul>
        </li>

        {/* COMMENT 2 */}
        <li>
          <div className="comment_item">
            <div className="comment_author_thumbnail">
              <img src={avatar4} alt="Avatar" />
            </div>

            <div className="comment_author_content">
              <h4 className="comment_author_name">Carter Vaughn</h4>
              <div className="comment_time">November 28, 2026</div>
              <p>"Support answered me in under two minutes on Telegram. Order started fast and finished clean. Good service."</p>

              <Link to="/blod-details" className="comment_reply_btn xb-border">
                Reply
              </Link>
            </div>
          </div>
        </li>

      </ul>
    </div>
  );
};

export default CommentsArea;
